export enum ItemTypeEnum {
    Product = 'product',
    Section = 'section',
    SubSection = 'subsection',
}